const passwordFactory = {
  toAPI: (data, token) =>
    data &&
    token && {
      token,
      password: data.newPassword
    }
}

export default passwordFactory



// WEBPACK FOOTER //
// ./src/app/pages/CreateNewPassword/factory.js